<template>
  <b-sidebar
    id="sidebar-right-company"
    :width="width"
    right
    backdrop
    body-class="p-0"
    no-header
    no-close-on-route-change
    no-close-on-backdrop
    lazy
    @hidden="closeCompanySidebar"
  >
    <template #default="{ hide }">
      <div class="detail-widget">
        <div
          v-if="!loading"
          class="detail-widget__field detail-widget__left"
        >
          <div class="detail-widget__top">
            <b-icon-arrow-bar-left
              class="detail-widget__back cursor-pointer"
              font-scale="2"
              @click="hide"
            />
            <b-skeleton-wrapper>
              <div class="d-flex mb-2 flex-wrap align-items-center">
                <h2 class="title text-light">Компания #{{ detailedItem.id }}</h2>
                <div class="buttons">
                  <button
                    v-if="!isAgent"
                    class="mr-2 btn btn-outline-light"
                    @click="openCreateTaskSidebar"
                  >
                    Создать задачу
                  </button>

                  <button
                    @click="createRequest"
                    class="btn btn-outline-light mr-2"
                    >
                      Создать заявку
                  </button>

                  <b-button @click="refreshCompany" size="sm" variant="outline-light">
                    <b-icon
                      icon="arrow-repeat"
                      scale="1.5"
                      aria-label="Reload"
                      :animation="loading ? 'spin' : ''"
                    ></b-icon>
                  </b-button>
                </div>
              </div>

              <div class="d-flex flex-wrap align-items-center">
                <h2 class="title text-light">{{ detailedItem.name }}</h2>
                <div class="buttons">
                  <button
                    class="btn btn-outline-light"
                    @click="
                      $router.push({
                        query: {
                          ...$route.query,
                          'edit-company': !editStatus,
                        },
                      })
                    "
                  >
                    {{ editStatus ? "Отмена" : "Редактировать" }}
                  </button>

                  <button
                    class="btn btn-outline-light show-history-button ml-2"
                    @click="viewCommentsBlock"
                  >
                    {{ showButtonText }}
                  </button>
                </div>
              </div>
            </b-skeleton-wrapper>

            <button
              class="detail-widget__top-copy-button"
              @click="copyLink"
            >
              <b-icon
                icon="link45deg"
                scale="2"
              ></b-icon>
            </button>
          </div>

          <div class="detail-widget__card">
            <b-overlay class="h-100" :show="loading">
              <template v-if="detailedItem.id">
                <tsoft-edit-company
                  v-if="editStatus"
                  class="pt-3"
                  :editedItem="detailedItem"
                  @change-company="setEditCompanyData"
                >
                  <template #footer>
                    <b-overlay
                      :show="saving"
                      rounded
                      opacity="0.8"
                      spinner-small
                      spinner-variant="success"
                      class="ml-auto"
                    >
                      <b-button
                        variant="success"
                        class="text-right"
                        @click="updateCompany"
                      >
                        Сохранить изменения
                      </b-button>
                    </b-overlay>
                  </template>
                </tsoft-edit-company>

                <b-tabs 
                  lazy
                  v-show="!editStatus"
                  nav-class="nav-widget"
                  nav-wrapper-class="p-0"
                >
                  <b-tab @click="deleteQueryTab">
                    <template #title>
                      <div>Детали</div>
                    </template>
                    <tsoft-company-details
                        :detailedItem.sync="detailedItem"
                        :key="reloadComponent"
                    />
                  </b-tab>

                  <b-tab :active="companyTab === 'company-documents'">
                    <template #title>
                      <div>Документы</div>
                    </template>
                    <template v-if="!isDocGenerator">
                      <div class="d-flex" style="justify-content: space-between;">
                        <h5>Документы по компании</h5>
                        <div>
                          <b-button @click="isDocGenerator=!isDocGenerator">Генератор документов</b-button>
                        </div>
                      </div>
                      <tsoft-show-edit-documents
                          :companyId="detailedItem.id"
                          :requestDocuments="detailedItem.id ? true : false"
                          :excludeAddDocumentTypeArray="[]"
                          :updateListDocument="singleOrMultiDocuments"
                          @clearDocumentList="clearDocumentList"
                          @onFileOperationCompleted="onFileOperationCompleted"
                      />
                      <tsoft-create-documents
                          :needMultiUploadDocuments="true"
                          :companyId="detailedItem.id"
                          :excludeAddDocumentTypeArray="[]"
                          @updateViewDocument="documentOutput"
                          @documentLoaded="onCloseSidePanelLoadingDocument"
                          @onFileOperationCompleted="onFileOperationCompleted"
                      />
                    </template>
                    <template v-if="isDocGenerator">
                      <div class="d-flex" style="justify-content: space-between;">
                        <h5>Генератор типовых договоров</h5>
                        <div>
                          <b-button @click="isDocGenerator=!isDocGenerator">К документам</b-button>
                        </div>
                      </div>
                      <div class="mt-3">
                        <CompanyGeneratorTD
                          :companyId="detailedItem.id"
                        ></CompanyGeneratorTD>
                      </div>
                    </template>
                  </b-tab>

                  <b-tab :active="companyTab === 'company-payments'">
                    <template #title>
                      <div>Платёжные реквизиты</div>
                    </template>
                    <tsoft-create-payment-details
                        :companyId="detailedItem.id"
                        :changeLoad.sync="changeLoad"
                    />
                  </b-tab>

                  <template v-if="detailedItem.is_transport_company">
                    <b-tab :active="companyTab === 'company-insurance'">
                      <template #title>
                        <div>Страхование</div>
                      </template>
                      <h5 class="mb-4">Страхование ответственности</h5>
                      <tsoftCompanyInsurance
                          :is-need-create="true"
                          :companyId="detailedItem.id"
                          :additionalGetParameter="`&company_id=${detailedItem.id}`"
                      />
                    </b-tab>
                  </template>

                  <template v-if="detailedItem.is_transport_company">
                    <b-tab :active="companyTab === 'company-transport-type'">
                      <template #title>
                        <div>Подвижной состав</div>
                      </template>
                      <h5 class="mb-4">Подвижной состав</h5>
                      <tsoftCompanyTransportTypes
                          :additionalGetParameter="`&company_id=${detailedItem.id}`"
                          :companyId="detailedItem.id"
                          :services="detailedItem.services"
                      />
                    </b-tab>
                  </template>

                  <b-tab :active="companyTab === 'company-employees'">
                    <template #title>
                      <div>Контакты</div>
                    </template>
                    <h5 class="mb-4">Сотрудники и контакты компании</h5>
                    <tsoft-company-employees
                        :companyId="detailedItem.id"
                        :additionalGetParameter="`&company_id=${detailedItem.id}`"
                        :changeLoad.sync="changeLoad"
                        :services="detailedItem.services"
                    />
                  </b-tab>

                  <template v-if="!isB2CAccount && !isAgent">
                    <b-tab :active="companyTab === 'company-geography'">
                        <template #title>
                        <div>География</div>
                        </template>
                        <h5 class="mb-4">География компании</h5>
                        <tsoftCompanyGeography
                            :companyId="detailedItem.id"
                            :uploading_geography="detailedItem.uploading_geography"
                            :unloading_geography="detailedItem.unloading_geography"
                            :transit_directions="detailedItem.transit_directions"
                            :rf_directions="detailedItem.rf_directions"
                        />
                    </b-tab>
                  </template>

                  <b-tab :active="companyTab === 'company-tasks'" v-if="!isAgent">
                    <template #title>
                      <span>Задачи</span>
                    </template>
                    <h5 class="mb-4">Задачи по компании</h5>
                    <tsoft-history-task
                        :modelName="'company_id'"
                        :modelId.sync="detailedItem.id"
                        :changeLoadTaskList.sync="changeLoad"
                    />
                  </b-tab>

                  <template v-if="!isB2CAccount && !isAgent">
                    <b-tab :active="companyTab === 'company-orders'">
                        <template #title>
                        <div>Заказы</div>
                        </template>
                        <h5 class="mb-4">
                          {{ detailedItem.is_transport_company ? 'Заказы, где компания подрядчик' : 'Заказы компании' }}
                        </h5>
                        <tsoft-company-order-table
                            :companyId="detailedItem.id"
                            :isTransportCompany="!!detailedItem.is_transport_company"
                        />
                    </b-tab>
                  </template>
                  
                  <b-tab :active="companyTab === 'company-finance'" v-if="!isAgent">
                    <template #title>
                      <div>Финансы</div>
                    </template>
                    <h5 class="mb-4">Счета компании</h5>
                    <tsoft-finance-finder-creator
                        id="companyAccounts"
                        :exportXLSX="`Счета компании ${detailedItem.name}`"
                        :is-need-create="isB2CAccount ? true : false"
                        :additionalGetParameter="(detailedItem.is_transport_company
                          ? `&transport_company_id=${detailedItem.id}`
                          : `&external_company_id=${detailedItem.id}`) + '&headerName=tableHeadersWithOrder'"
                        :typeOfTableFilter="'finance'"
                        :company_id="detailedItem.id"
                    />
                  </b-tab>
<!-- 
                  <template v-if="detailedItem.is_transport_company">
                    <b-tab :active="companyTab === 'company-trucks'">
                      <template #title>
                        <div>Транспорт</div>
                      </template>
                      <h5 class="mb-4">Транспорт компании</h5>
                      <tsoft-trucks
                          :is-need-create="true"
                          :additionalGetParameter="`&company_id=${detailedItem.id}`"
                      />
                    </b-tab>
                    <b-tab :active="companyTab === 'company-drivers'">
                      <template #title>
                        <div>Водители</div>
                      </template>
                      <h5 class="mb-4">Водители компании</h5>
                      <tsoft-drivers
                          :is-need-create="true"
                          :additionalGetParameter="`&company_id=${detailedItem.id}`"
                      />
                    </b-tab>
                  </template> -->

                  <!-- CompanyDetailWidget.vue -->
                  <b-tab v-if="isB2CAccount" :active="companyTab === 'company-service-constructor'">
                    <template #title>
                        <div>Конструктор услуг</div>
                    </template>
                    <!-- <h5 class="mb-4">Услуги компании</h5> -->
                    <CompanyFinanceServiceConstructor
                        :companyId="detailedItem.id"
                        :services="detailedItem.services"
                    />
                  </b-tab>

                  <b-tab :active="companyTab === 'company-statistics'" v-if="!isAgent">
                    <template #title>
                      <div>Статистика</div>
                    </template>
                    <h5 class="mb-4">Статистика компании</h5>
                    <tsoft-company-finance-statistic 
                      :companyId="detailedItem.id" 
                      :isTransportCompany="!!detailedItem.is_transport_company"
                      :additionalGetParameter="detailedItem.is_transport_company
                        ? `?transport_company_id=${detailedItem.id}`
                        : `?external_company_id=${detailedItem.id}`"
                    />
                  </b-tab>

                  <b-tab :active="companyTab === 'company-history'">
                    <template #title>
                      <div>История</div>
                    </template>
                    <tsoft-company-history
                      :companyId="detailedItem.id"
                      :reload="historyReload"
                    />
                  </b-tab>
                </b-tabs>
              </template>
            </b-overlay>
          </div>
        </div>

        <div
          v-if="!loading"
          ref="companyDetailWidget"
          :style="{ maxWidth: `${widthRightBar}px` }"
          class="detail-widget__field detail-widget__right resizable-bar"
        >
          <div
            @mousedown="mouseDown($event, 'companyDetailWidget', 600)"
            @dblclick="viewCommentsBlock"
            class="drag-line"
          ></div>
          <b-skeleton-wrapper
            class="h-100 d-flex flex-column"
            :loading="loading"
          >
            <template #loading>
              <div v-for="(skeleton, index) in 4" class="p-3">
                <div class="d-flex align-items-center mb-3">
                  <b-skeleton
                    class="mr-3 flex-shrink-0"
                    type="avatar"
                  ></b-skeleton>
                  <b-skeleton width="100%"></b-skeleton>
                </div>
                <b-skeleton height="10px"></b-skeleton>
                <b-skeleton class="my-3" height="10px"></b-skeleton>
              </div>
              <b-skeleton class="mt-auto" height="200px"></b-skeleton>
            </template>

            <div class="d-flex flex-column h-100">
              <CompanyComments 
                :company-id="detailedItem.id" 
                @update="updateCompanyInTable"
              />
            </div>
          </b-skeleton-wrapper>
        </div>

        <div v-else>
          <b-overlay
            :show="true"
            no-wrap
          >
            <template #overlay>
              <div class="text-center text-success my-5">
                <b-spinner variant="success"></b-spinner>
              </div>
              <div class="text-center">Ожидайте...</div>
            </template>
          </b-overlay>
        </div>
      </div>

      <CreateTaskWidget
        :companyId="detailedItem.id"
        @setToGetAllHistoryTasks="changeLoad = !changeLoad"
        @openCreateTaskSidebar="openCreateTaskSidebar"
      />

      <OrderCreateModal :company="detailedItem" />
    </template>
  </b-sidebar>
</template>

<script>
import tsoftEditCompany from '@components/companies/EditCompany';
import tsoftCompanyDetails from '@components/companies/CompanyDetails';
import tsoftCompanyOrderTable from '@components/orders/Order';
import tsoftFinanceFinderCreator from '@components/finance/FinanceFinderAndCreator';
import tsoftCompanyInsurance from '@/views/CompanyInsurance';
import tsoftCompanyTransportTypes from '@components/companies/CompanyTransportTypes';
import tsoftCompanyGeography from '@components/companies/CompanyGeography';
import tsoftTrucks from '@/views/Truck';
import tsoftDrivers from '@/views/Driver';
import tsoftCompanyEmployees from '@components/employees/EmployeesFinderAndCreator';
import tsoftCreatePaymentDetails from '@components/companies/CreatedOrEditedPaymentDetails';
import tsoftCompanyHistory from '@components/companies/CompanyHistory';
import tsoftCompanyFinanceStatistic from '@components/companies/CompanyFinanceStatistic';
import CompanyGeneratorTD from '@components/companies/CompanyGeneratorTD';
import CompanyComments from '@components/companies/CompanyComments';
import OrderCreateModal from '@components/orders/OrderCreateModal';
import CreateTaskWidget from '@/components/task/CreateTaskWidget.vue';
import CompanyFinanceServiceConstructor from '@/components/companies/constructors/CompanyFinanceServiceConstructor';

import { API_COMPANY } from '@/constants';
import { mixinDocuments } from '@/mixins/mixinDocuments';
import { defaultDataItems } from '@/mixins/defaultDataItems';
import { openCreateTaskSidebar } from '@/mixins/openTasksSidebar';
import { copyLink } from '@/mixins';

import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    tsoftEditCompany,
    tsoftCompanyDetails,
    tsoftCompanyOrderTable,
    tsoftFinanceFinderCreator,
    tsoftCompanyInsurance,
    tsoftCompanyTransportTypes,
    tsoftCompanyGeography,
    tsoftTrucks,
    tsoftDrivers,
    tsoftCompanyEmployees,
    tsoftCreatePaymentDetails,
    tsoftCompanyHistory,
    tsoftCompanyFinanceStatistic,
    CompanyGeneratorTD,
    CompanyComments,
    OrderCreateModal,
    CreateTaskWidget,
    CompanyFinanceServiceConstructor
  },

  props: {
    width: {
      type: String,
      require: true,
    }
  },

  mixins: [
    mixinDocuments,
    defaultDataItems,
    openCreateTaskSidebar,
    copyLink,
  ],

  data() {
    return {
      detailedItem: {},
      editCompanyData: {},
      changeLoad: false,
      historyReload: 0,
      loading: true,
      reloadComponent: 0,
      isDocGenerator: false,
      saving: false,
      countOfWidthRightBar: '',
    }
  },

  methods: {
    ...mapActions('companyDetail', ['companyWidgetSetValue']),

    loadOneItem() {
      return api.call('get', `${API_COMPANY}/${+this.$route.query.company}`).then(({data}) => {
        this.detailedItem = data;
        this.loading = false;
      })
    },
    closeCompanySidebar() {
      const query = Object.assign({}, this.$route.query);
      delete query.company;
      delete query['edit-company'];
      delete query['tab-company'];
      this.$router.replace({ query });
    },
    deleteQueryTab() {
      if (this.$route.query['tab-company']) {
        const query = Object.assign({}, this.$route.query);
        delete query['tab-company'];
        this.$router.replace({ query });
      }

      this.refreshCompany();
    },
    // when file updated or loaded
    onFileOperationCompleted(status) {
      this.reloadComponent++
    },
    onCloseSidePanelLoadingDocument(value) {
      if(value == true){
        this.checkedLoadDocument = false
      }
    },
    async updateCompany() {
      if (this.editCompanyData === 'error') {
        this.makeToast('danger', 'Ошибка в заполнении формы');
        return
      }
      this.saving = true;
      const { data } = await axios.put(
        `${API_COMPANY}/${+this.$route.query.company}`,
        this.editCompanyData
      );
      this.$router.push({
        query: {
          ...this.$route.query,
          'edit-company': false,
        },
      });
      // История перезагружается после обновления карточки: запись лога пишется уже после ответа сервера
      this.loadOneItem().then(() => {
        this.historyReload++;
      });
      this.companyWidgetSetValue(data);
      this.$toast.success('Изменения сохранены');
      this.saving = false;
    },
    updateCompanyInTable(last_comment) {
      this.detailedItem.last_comment = last_comment[last_comment.length - 1];
      this.companyWidgetSetValue(this.detailedItem);
    },
    setEditCompanyData(value) {
      this.editCompanyData = value;
    },
    isCommentOpened() {
      this.countOfWidthRightBar = JSON.parse(localStorage.getItem('userSettingsCompany')).companyDetailWidget;
    },
    viewCommentsBlock() {
      if (this.countOfWidthRightBar === 2) {
        this.$refs.companyDetailWidget.style.maxWidth = '380px';
        localStorage.setItem('userSettingsCompany', '{"companyDetailWidget": 380}');
      } else {
        this.$refs.companyDetailWidget.style.maxWidth = '2px';
        localStorage.setItem("userSettingsCompany", '{"companyDetailWidget": 2}');
      }
      this.isCommentOpened();
    },
    mouseDown(e, elemName, maxWidth) {
      const el = this.$refs[elemName];
      this.setListener(e, el, elemName, maxWidth);
    },
    setListener(e, el, elemName, maxWidth) {
      const BORDER_SIZE = 2;
      const DEFAULT_SIZE = maxWidth;
      const dragElement = el.children[0];

      function resize(e) {
        let m_pos = window.innerWidth - e.x;

        if (m_pos >= BORDER_SIZE) {
          el.style.maxWidth = `${m_pos}px`;
          localStorage.setItem(
            'userSettingsCompany',
            JSON.stringify({
              [elemName]: m_pos,
            })
          );
        }

        if (m_pos > DEFAULT_SIZE) {
          el.style.maxWidth = `${DEFAULT_SIZE}px`;
          localStorage.setItem(
            'userSettingsCompany',
            JSON.stringify({
              [elemName]: DEFAULT_SIZE,
            })
          );
        }

        if (m_pos <= BORDER_SIZE) {
          el.style.maxWidth = `${BORDER_SIZE}px`;
          localStorage.setItem(
            'userSettingsCompany',
            JSON.stringify({
              [elemName]: BORDER_SIZE,
            })
          );
        }
      }

      const mouseUp = () => {
        this.isCommentOpened();
        el.classList.remove("moved");
        window.removeEventListener("mousemove", resize);
        window.removeEventListener("mouseup", mouseUp);
      }

      if (e.target === dragElement) {
        el.classList.add("moved");
        window.addEventListener("mousemove", resize);
      }

      window.addEventListener("mouseup", mouseUp);
    },
    refreshCompany() {
      this.loading = true;

      Promise.all([this.loadOneItem()]).then(() => {
        this.loading = false;
      });
    },
    createRequest() {
      this.$root.$emit('bv::toggle::collapse', 'create-order-modal');
    },
  },

  computed: {
    ...mapGetters("auth", ["currentUser"]),

    isB2CAccount() {
      return this.currentUser.role.includes('b2c-head-manager') || 
             this.currentUser.role.includes('b2c-manager');
    },

    isAgent() {
      return this.currentUser.role.includes('agent');
    },

    companyTab() {
      return this.$route.query['tab-company'];
    },
    editStatus() {
      return this.$route.query['edit-company'] === 'true';
    },
    widthRightBar() {
      if (typeof localStorage.userSettingsCompany === 'undefined' || localStorage.userSettingsCompany === null) {
        localStorage.setItem('userSettingsCompany', '{"companyDetailWidget":436, "tablePerPage":25}');
      }
      return JSON.parse(localStorage.getItem('userSettingsCompany')).companyDetailWidget;
    },
    showButtonText() {
      return this.countOfWidthRightBar <= 10 ? 'Открыть чат' : 'Скрыть чат';
    },
  },

  mounted() {
    this.loadOneItem();
    if (window.innerWidth > 991) {
      this.isCommentOpened();
    }
  },
}
</script>

<style lang="scss" scoped>
$bg-top: #0d6247;

.buttons {
  display: flex;
  flex-wrap: wrap;
  margin-left: auto;

  @media screen and (max-width: 991px) {
    margin-left: 0;
  }
}

.textarea-form {
  min-width: 400px;
  @media screen and (max-width: 991px) {
    min-width: 100%;
  }
}

.title {
  margin-bottom: 0;

  @media screen and (max-width: 991px) {
    margin-bottom: 0.5rem;
    font-size: 1rem;
    width: 100%;
  }
}

.subtitle {
  @media screen and (max-width: 991px) {
    font-size: 1.1rem;
    margin-left: -40px;
  }
}

.detail-widget {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    position: relative;
  }

  &__left {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    @media screen and (max-width: 991px) {
      min-height: 100vh;
    }
  }

  &__right {
    width: 100%;
    background-color: #f5f5f5;
    position: relative;
    @media screen and (max-width: 991px) {
      max-width: 100% !important;
    }

    &.collapses {
      transition: width 0.3s;
    }
  }

  &__top {
    position: relative;
    color: #fff;
    background-color: $bg-top;
    padding: 15px 1.5rem 15px 3rem;
    min-height: 110px;

    &-copy-button {
      position: absolute;
      top: 65px;
      left: 10px;
      border: none;
      outline: none;
      background-color: transparent;
      color: #fff;
    }
  }

  &__card {
    flex: 1;
    overflow-x: hidden;

    ::v-deep .tabs {
      display: flex;
      height: 100%;
      margin: 0;
      @media screen and (max-width: 991px) {
        flex-direction: column;
      }

      .nav-widget {
        background-color: $bg-top;
        height: 100%;
        flex-wrap: nowrap;
        overflow: auto;
        min-width: 130px;
        width: 100%;
        flex-direction: column;
        @media screen and (max-width: 991px) {
          flex-direction: row;
          height: auto;
          overflow-y: hidden;
        }
        .nav-link {
          text-align: left;
          border-radius: 0 !important;
          padding: 15px 10px !important;
          font-size: 14px !important;
          line-height: 1.1;
          font-weight: 700;
          color: #fff;
          min-width: 100px;
          border: none;
          text-transform: uppercase;
          @media screen and (max-width: 991px) {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 10px !important;
          }
          &.active {
            color: #000 !important;
            background-color: #fff;
          }
          &:hover {
            color: #000 !important;
            background: #fff;
          }
        }
      }

      .tab-content {
        overflow: auto;
        height: 100%;
        width: 100%;
        padding: 15px 22px;
        @media screen and (max-width: 991px) {
          overflow: inherit;
          padding: 15px 5px;
        }

        &::-webkit-scrollbar {
          width: 7px;
          border-radius: 0 !important;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 0 !important;
          cursor: pointer;
        }
      }
    }
  }

  &__back {
    font-size: 200%;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .show-history-button {
    @media screen and (max-width: 991px) {
      display: none;
    }
  }
}
</style>